module.exports = __webpack_public_path__ + "static/complex_scroll_6-ce97bbaea12764928cd24e0902e27ff1.png";